module.exports = "/cyber/_next/static/images/mistletoe-27b5c3500c96a79454014b3d44de0f15.png";